<template>
  <div class="backdrop">
    <div class="backdrop-top" :style="[stocktaking_info.status == 0 ? {'height': 'calc(100% - 58px)'} : {'height': '100%'}]">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>耗材盘点单详情</span>
      </div>
      <div class="header-wrapper">
        <div class="header-box">
          <div class="mar_bot title">
            <span>{{stocktaking_info.stocktaking_title}}</span>
            <span class="btn" v-if="stocktaking_info.status == 1">已入账</span>
            <span class="btn" v-else>未入账</span>
          </div>
          <div class="layout mar_bot">
            <div class="flex-1"><label>创建人</label>{{stocktaking_info.create_member_name}}</div>
            <div class="flex-1"><label>盘点总数</label>{{stocktaking_info.total_rows}}</div>
          </div>
          <div class="layout mar_bot">
            <div class="flex-1"><label>创建时间</label>{{stocktaking_info.create_time_info}}</div>
            <div class="flex-1"><label>盘点仓库</label>{{stocktaking_info.storage_name}}</div>
          </div>
          <div class="layout">
            <div class="flex-1"><label>入账时间</label>{{stocktaking_info.enter_time_info}}</div>
          </div>
        </div>
      </div>
      <div class="center-wrapper">
        <div class="layout center-box">
          <div class="flex-1" @click="check_status=0" :class="check_status == 0 ? 'blue':' '">
            <label>待盘<img v-if="check_status == 0" src="../../../assets/images/asset-right_jt_blue.png"><img v-else src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking_info.wait_rows}}</div>
          </div>
          <div class="flex-1" @click="check_status=1" :class="check_status == 1 ? 'blue':' '">
            <label>盘平<img v-if="check_status == 1" src="../../../assets/images/asset-right_jt_blue.png"><img v-else src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking_info.balance_rows}}</div>
          </div>
          <div class="flex-1" @click="check_status=2" :class="check_status == 2 ? 'blue':' '">
            <label>盘盈<img v-if="check_status == 2" src="../../../assets/images/asset-right_jt_blue.png"><img v-else src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking_info.profit_rows}}</div>
          </div>
          <div class="flex-1" @click="check_status=3" :class="check_status == 3 ? 'blue':' '">
            <label>盘亏<img v-if="check_status == 3" src="../../../assets/images/asset-right_jt_blue.png"><img v-else src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking_info.loss_rows}}</div>
          </div>
        </div>
      </div>
      <div class="list-wrapper">
        <div class="list-li" v-for="(detail, detail_key) in stocktaking_info.goods" :key="detail_key" v-if="detail.stocktake_status == check_status" @click="toDetail(detail_key)">
          <div class="title">{{detail.goods_name}}<img class="more" src="../../../assets/images/asset-more.png"></div>
          <div class="code"><label>物品编码</label>{{detail.goods_num}}</div>
          <div class="type layout">
            <div class="flex-1">
              <label>应盘</label>
              <div class="num">{{detail.due_count}}</div>
            </div>
            <div class="flex-1">
              <label>实盘</label>
              <div class="num" v-if="detail.stocktake_status > 0">{{detail.real_count}}</div>
              <div class="num" v-else>待盘</div>
            </div>
            <div class="flex-1">
              <label>盈亏数量</label>
              <div class="num" v-if="detail.stocktake_status > 0">{{detail.profit_and_loss_count}}</div>
              <div class="num" v-else>待盘</div>
            </div>
            <div class="flex-1">
              <label>盈亏金额</label>
              <div class="num" v-if="detail.stocktake_status > 0">{{detail.profit_and_loss_amount}}</div>
              <div class="num" v-else>待盘</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrapper" v-if="stocktaking_info.status == 0 && come_from_approval != 1">
      <div @click="$router.push({name: 'StocktakingEnterCode', query: {stocktaking_id: stocktaking_id}})">录码</div>
      <div @click="scanCode">扫码</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'StocktakingInfo',
  metaInfo: {
    title: '耗材盘点单详情'
  },
  data () {
    return {
      stocktaking_id: 0,
      stocktaking_info: [],
      check_status: 0,
      input_goods_num: '', // 盘点物品编码（扫码或录码结果）
      come_from_approval: 0 // 审批页面调过来时传come_from_approval=1,不展示操作按钮
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    this.stocktaking_id = this.$route.query.stocktaking_id
    if (this.$route.query.come_from_approval) {
      this.come_from_approval = this.$route.query.come_from_approval
    }
    this.getStocktakingInfo()

    let url = window.location.href.split('#')[0]
    this.axios.post('/wechat/index/getticket', {
      url,
      village_id: this.villageId
    }).then((res) => {
      this.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.data.signature, // 必填，签名
        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表 hideMenuItems
      })
      this.wx.ready(() => {
        console.log('成功')
      })
      this.wx.error(function (res) {
        console.log('失败')
      })
    })
  },
  methods: {
    // 获取盘点单信息
    getStocktakingInfo () {
      this.axios.post('/wechat/stocktaking/getStocktakingInfo', {
        member_id: this.memberId,
        village_id: this.villageId,
        stocktaking_id: this.stocktaking_id
      }).then((res) => {
        if (res.data.status === 1) {
          this.stocktaking_info = res.data.data.stocktaking_info
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 详情
    toDetail (key) {
      if (this.come_from_approval === 1) {
        return false
      }
      var detail = this.stocktaking_info['goods'][key]
      if (this.stocktaking_info.handwork_allow === 0 && detail.stocktake_status === 0) {
        // 不允许手动盘点的单子，待盘不能点入
        return false
      }
      var showStocktakeBtn = 0
      if (this.stocktaking_info.status === 0 && !this.stocktaking_info.approval) {
        showStocktakeBtn = 1
      }
      this.$router.push({name: 'StocktakingDetail', query: {stocktaking_id: this.stocktaking_id, show_stocktake_btn: showStocktakeBtn, detail: JSON.stringify(detail)}})
    },
    // 扫码
    scanCode () {
      let that = this
      this.wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          var str = result.split(',')
          that.input_goods_num = str[1]
          // that.input_goods_num = '6915324846033' // 用于本地测试
          that.checkCode()
        }
      })
    },
    // 物品编码校验
    checkCode () {
      if (this.input_goods_num === '') {
        this.$toast({
          message: '未获取到物品编码',
          duration: 2000
        })
        return false
      }
      // 判断是否在物品档案中
      this.axios.post('/wechat/goods/goodsDetail', {
        member_id: this.memberId,
        village_id: this.villageId,
        goods_num: this.input_goods_num
      }).then((res) => {
        if (res.data.status === 1) {
          var goodsInfo = res.data.data
          if (goodsInfo.goods_type !== 1) {
            this.$messagebox({
              message: '未找到编号' + this.input_goods_num + '耗材',
              closeOnClickModal: false,
              showCancelButton: false,
              confirmButtonText: '确定'
            })
            return false
          }
          // 判断耗材是否在盘点单内
          this.axios.post('/wechat/stocktaking/getStocktakingInfo', {
            member_id: this.memberId,
            village_id: this.villageId,
            stocktaking_id: this.stocktaking_id,
            goods_id: goodsInfo.goods_id
          }).then((res2) => {
            if (res2.data.status === 1) {
              if (res2.data.data.stocktaking_info.goods.length > 0) {
                // 在盘点单内
                var detail = res2.data.data.stocktaking_info.goods[0]
                this.$router.push({name: 'StocktakingDetail', query: {stocktaking_id: this.stocktaking_id, show_stocktake_btn: 1, detail: JSON.stringify(detail)}})
              } else {
                // 不在盘点单内
                this.$messagebox({
                  message: '该耗材不在本次盘点范围，是否继续盘点',
                  closeOnClickModal: false,
                  showCancelButton: true,
                  confirmButtonText: '盘点'
                }).then(action => {
                  if (action === 'confirm') { // 确认的回调
                    var detail = {}
                    detail.goods_id = goodsInfo.goods_id
                    detail.goods_num = goodsInfo.goods_num
                    detail.goods_name = goodsInfo.goods_name
                    detail.due_count = 0
                    this.$router.push({name: 'StocktakingDetail', query: {stocktaking_id: this.stocktaking_id, show_stocktake_btn: 1, detail: JSON.stringify(detail)}})
                  }
                })
              }
            }
          }).catch(() => {
            this.$toast({
              message: '网络错误',
              duration: 5000
            })
          })
        } else {
          this.$messagebox({
            message: '未找到编号' + this.input_goods_num + '耗材',
            closeOnClickModal: false,
            showCancelButton: false,
            confirmButtonText: '确定'
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.backdrop {
  background-color: #f6f6f6;
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.title-box {
  background-color: #7090fd;
  color: #ffffff;
}
.header-wrapper {
  background-color: #7090fd;
  padding: 5px 15px 15px 15px;
}
.header-wrapper .header-box {
  background-color: #8ca6fd;
  border-radius: 5px;
  font-size: 12px;
  color: #ffffff;
  padding: 10px;
}
.header-wrapper .header-box .title {
  font-size: 16px;
  display: flex;
}
.header-wrapper .header-box .title span:first-child {
  flex: 1;
}
.header-wrapper .header-box .title .btn {
  background-color: #c7d3fc;
  font-size: 14px;
  border-radius: 4px;
  padding: 1px 5px;
}
.center-wrapper {
  background-color: #ffffff;
  padding: 10px;
  margin-bottom: 8px;
}
.center-wrapper .center-box {
  background-color: #f6f6f6;
  padding: 10px;
}
.center-wrapper .center-box .flex-1 {
  text-align: center;
}
.center-wrapper .center-box label {
  color: #999 !important;
  font-size: 14px;
}
.center-wrapper .center-box label img {
  width: 9px;
  height: 9px;
  padding-left: 3px;
}
.center-wrapper .center-box .num {
  font-size: 16px;
  margin-top: 10px;
  font-weight: 600;
}
.center-wrapper .center-box .blue label {
  color: #7090fd !important;
}
.center-wrapper .center-box .blue .num {
  color: #7090fd !important;
}
.list-wrapper {
  overflow-y: auto;
}
.list-wrapper .list-li {
  background-color: #ffffff;
  margin-bottom: 8px;
  padding: 10px;
}
.list-wrapper .list-li:last-child {
  margin-bottom: 0;
}
.list-wrapper .list-li .title {
  font-size: 15px;
  font-weight: 600;
  position: relative;
}
.list-wrapper .list-li .title span {
  font-weight: normal;
  background-color: #7090fd;
  color: #ffffff;
  padding: 2px 3px;
  margin-left: 5px;
  font-size: 12px;
  border-radius: 2px;
}
.list-wrapper .list-li .title .more {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 2px;
  right: 0;
}
.list-wrapper .list-li .code {
  font-size: 13px;
  padding: 6px 0;
}
.list-wrapper .list-li .code label {
  color: #999;
  padding-right: 5px;
}
.list-wrapper .list-li .type label {
  font-size: 13px;
  color: #999999;
}
.list-wrapper .list-li .type .num {
  font-size: 14px;
  color: #313131;
}
.footer-wrapper {
  width: 100%;
  height: 50px;
  border: none;
  font-size: 16px;
  letter-spacing: 2px;
  color: #313131;
  display: flex;
  background-color: #ffffff;
  margin-top: 8px;
}
.footer-wrapper div {
  flex: 1;
  line-height: 50px;
  text-align: center;
}
.layout {
  display: flex;
}
.layout .flex-1 {
  flex: 1;
}
.layout .flex-1 label {
  color: #b2cfff;
  display: inline-block;
  width: 64px;
}
.mar_bot {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Stocktaking/StocktakingInfo.vue